module.exports = __webpack_public_path__ + "app/prepasrel/list-workflows-EI2bawMf.html";